import { render, staticRenderFns } from "./AmSelect.vue?vue&type=template&id=2fb34228&"
import script from "./AmSelect.vue?vue&type=script&lang=js&"
export * from "./AmSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports